import { propertyTypesQueryKeys as e } from "./usePropertyTypesQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { propertyTypesApi as r } from "@maat/api-main";
//#region src/propertyTypes/useCreatePropertyType.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: async (e) => r.createPropertyType(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.list() });
		}
	});
};
//#endregion
export { i as useCreatePropertyType };
